import { ProgramsBox } from '../../../components';
import './ProgramsViewContent.css';
import { NoItemView } from '../../../components/NoItemView';
import React from 'react';
import { useProfilePrograms } from '../../../hooks';

export const ProgramsViewContent = () => {
  const { profilePrograms, profileProgramsLoaded } = useProfilePrograms();
  return (
    <span>
      <div className="ov_panel active" data-name="programs">
        <div className="br_cont">
          <div className="br_row">
            <div className="div-block-430 sl pathway_grid">
              <ProgramsBox
                profilePrograms={profilePrograms}
                profileProgramsLoaded={profileProgramsLoaded}
              ></ProgramsBox>
            </div>
          </div>
          {profileProgramsLoaded &&
            (!profilePrograms || profilePrograms.length === 0) && (
              <NoItemView
                displayMessage={"You don't have any earned programs yet."}
                displayPadding={true}
              />
            )}
        </div>
      </div>
    </span>
  );
};
